"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchUserActionEvent = dispatchUserActionEvent;
exports.getUserActionEventDispatcher = getUserActionEventDispatcher;
var _userAction = require("@ori-events/user-action");
var _constants = require("../constants");
var _log = require("./log");
/**
 * @param appName Application name / logger key.
 * @returns Function which triggers user-action event for analytics.
 */
function getUserActionEventDispatcher(appName) {
  return metaHierarchy => dispatchUserActionEvent(metaHierarchy, appName);
}

/**
 * Triggers user-action event for analytics.
 * @param metaHierarchy Array of predefined items describing current user action.
 */
function dispatchUserActionEvent(metaHierarchy, appName) {
  const logDebug = (0, _log.getDebugLogger)(appName ?? _constants.APP_NAME);
  logDebug(`Triggering ${_userAction.Name} event, metaHierarchy:`, metaHierarchy);
  (0, _userAction.dispatch)(metaHierarchy);
}
//# sourceMappingURL=dispatchUserActionEvent.js.map